/*
 * COPYRIGHT:     Copyright © 2020 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

const NONE_SELECT_LABEL = 'None'

export const RESET_SELECT_OPTION = { key: 0, label: NONE_SELECT_LABEL, value: null }
